export const Y_AXIS_LABEL_MIN_WIDTH_PX = 60
export const Y_AXIS_LABEL_CHAR_WIDTH_PX = 10
export const Y_AXIS_LABEL_PADDING_PX = 5
